import React, { Component } from 'react';
import classnames from 'classnames';
import autobind from 'autobind-decorator'

const Keys = {
    ENTER: 13,
    ESCAPE: 27,
};


class FilterContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterInputValue : '',
            focus: false
        };

        this.handleAddFilter = this.handleAddFilter.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.renderValue = this.renderValue.bind(this);
    }

    handleAddFilter(){
        const { propertyName, addFilter, actionValueValidator } = this.props;
        const value = this.state.filterInputValue.trim();
        // 추가 버튼을 클릭했는데 값이 비어 있는 경우는 처리하지 않음.
        if(value !== ''){
            if(actionValueValidator) {
                if(actionValueValidator(value)){
                    addFilter(propertyName, value);
                    this.setState({
                        filterInputValue : '',
                    });
                }
            }else{
                addFilter(propertyName, value);
                this.setState({
                    filterInputValue : '',
                });
            }
        }
        
    }

    handleRemoveFilter(item)
    {
        const { propertyName, removeFilter } = this.props;

        removeFilter(propertyName, item.value, item.id);


    }

    handleChange(event) {

        const value = event.target.value;
        const { inputValidator } = this.props;

        if(value !== '' && inputValidator) {
            if(inputValidator(value)){
                this.setState({
                    filterInputValue : value,
                });
            }
        }else{
            this.setState({
                filterInputValue : value,
            });
        }
    }

    @autobind
    handleFocus() {
        this.setState({
            focus: true
        })
    }

    @autobind
    handleBlur() {
        this.setState({
            focus: false
        })
    }


    handleKeyDown(e){
        if (e.keyCode === Keys.ENTER) {
            this.handleAddFilter();
        }
    }

    render() {

        const { title, placeholder, filters, propertyName, actionValueValidator, emptyLabel } = this.props;
        const { filterInputValue, focus } = this.state;
        const items = filters[propertyName];
        let actionButtonDisabled = false;
        if(actionValueValidator) {
            if(!actionValueValidator(filterInputValue))
                actionButtonDisabled = true;
        }else{
            actionButtonDisabled = (filterInputValue.length === 0);
        }

        return (
            <div className="item_filter">
                <strong className="tit_filter">{title}</strong>
                <div className={classnames('box_tf', {on_focus:focus, on_add:!actionButtonDisabled})}>
                    <input type="text" placeholder={placeholder} className="tf_filter" title={title + "입력"} value={filterInputValue}
                           onFocus={this.handleFocus}
                           onBlur={this.handleBlur}
                           onChange={this.handleChange}
                           onKeyDown={this.handleKeyDown}/>
                    <button type="button" className="btn_filter" disabled={actionButtonDisabled} onClick={this.handleAddFilter}><span className="ico_blog ico_add">추가</span></button>
                </div>
                { (items.length === 0) && <p className="box_filter txt_none">{emptyLabel}</p>}
                { (items.length > 0) && <ul className="box_filter list_filter">
                    {
                        items.map((item, idx) =>
                            (
                                <li key={idx}>
                                  <span className="txt_list">
                                      {this.renderValue(item.value)}
                                  </span>
                                  <button type="button" className="btn_del" onClick={(e) => this.handleRemoveFilter(item)}><span className="ico_blog ico_del">삭제</span></button>
                                </li>
                            )
                        )
                    }
                </ul>}
            </div>
        );
    }

    renderValue(value) {
        const { masker } = this.props;
        if(masker) {
            return masker(value);
        }else{
            return value;
        }
    }
}

export default FilterContainer;
